/** Inline IamResponding logo used in the Field Sharing recipients picker. */
const IarIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 180 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="180" height="180" fill="#E82629" />
    <g fill="#FFFFFF">
      <path d="M61.3,102.5c-6.9,0-14.4,3.1-14.4,11.1c0,6.1,5.3,9.7,11.3,9.7c3.7,0,7.5-1.2,10.7-4.6l0.3,3.8h4.1v-19.8c-0.1-8.5-3-13.6-12.7-13.6c-4.3,0-9.3,1.5-12.3,2.9l1.5,4.1c2.5-1.4,6.8-2.8,10.6-2.8c5.7,0,8.3,3,8.3,8.4v1.8C65.8,102.8,63.5,102.5,61.3,102.5z M68.7,114.6c-3.1,2.9-6.7,4.9-10.4,4.9c-3.8,0-6.9-2.5-6.9-6.5c0-5.1,5.2-6.9,9.7-6.9c2.3,0,4.8,0.3,7.6,0.9V114.6z" />
      <polygon points="27,79.9 31.1,79.9 31.1,118.3 27,118.3 27,122.4 40.1,122.4 40.1,118.3 36,118.3 36,79.9 40.1,79.9 40.1,75.8 27,75.8" />
      <path d="M153,90c0-15.8-6.8-30-17.5-39.9c-0.6-0.5-1.5-0.4-1.9,0.2l-1.1,1.5c-0.4,0.5-0.3,1.2,0.2,1.7c9.8,9.1,16,22.1,16,36.5s-6.2,27.4-16,36.5c-0.5,0.4-0.6,1.2-0.2,1.7l1.1,1.5c0.4,0.6,1.3,0.7,1.9,0.2C146.2,120,153,105.8,153,90z" />
      <path d="M109.8,122.4h6.1c-2.5-3.4-10.1-13.5-15.1-20.4c7.9-1.3,12.2-6.2,12.2-13.1c0-9.5-8.5-13.1-15.4-13.1H84.2v46.6h4.9v-20.3h6.1L109.8,122.4z M89.1,80.3h8.1c6.3,0,10.5,3.5,10.5,8.7c0,6.1-4.6,8.5-11.9,8.5h-6.7V80.3z" />
      <path d="M116.7,106.3l1.1,1.6c0.5,0.7,1.5,0.7,2,0.1c4.1-4.8,6.7-11.1,6.7-18c0-6.8-2.5-13.1-6.7-18c-0.5-0.6-1.5-0.6-2,0.1l-1.1,1.6c-0.3,0.5-0.3,1.1,0.1,1.6c3.3,4,5.3,9.1,5.3,14.7c0,5.6-2,10.7-5.3,14.7C116.4,105.2,116.4,105.8,116.7,106.3z" />
      <path d="M125.8,118.8c0.5,0.6,1.4,0.7,1.9,0.2c7.5-7.4,12.1-17.7,12.1-29s-4.7-21.6-12.1-29c-0.6-0.5-1.5-0.5-1.9,0.2l-1.1,1.5c-0.4,0.5-0.3,1.2,0.1,1.7c6.5,6.6,10.6,15.7,10.6,25.6c0,10-4,19.1-10.6,25.6c-0.4,0.4-0.5,1.1-0.1,1.7L125.8,118.8z" />
    </g>
  </svg>
);

export default IarIcon;
